import { LivePrice } from "@prisma/client"

import { BaseCourse } from "../server/dao/course_dao"
import { BaseUser } from "../server/dao/user_dao"
import { isUserSubscribedToCreator } from "../utils/user_util"
import { ECourseAccessTier } from "./../@types/course_types"

export default class PaymentsController {
    static getCoursePriceForUser = (
        course: BaseCourse,
        user: BaseUser,
        tier: ECourseAccessTier,
    ): LivePrice | null => {
        const isUserSubscribed = isUserSubscribedToCreator(user, course.creatorId)
        if (tier === ECourseAccessTier.First) {
            return isUserSubscribed ? course.subscriberCost : course.guestCost
        }
        return isUserSubscribed ? course.secondSubscriberCost : course.secondGuestCost
    }
}
